// Event links — curated URLs (menus, maps, ticketing, dress code…) organizers
// add to an event; they feed the attendee apps' Home/quick-links. Backed by the
// `event_links` resource + its custom actions (create/update/delete are locked
// behind actions, not generic CRUD). Mirrors the vendors.ts core convention.
import { api } from "./api"

export type EventLink = {
  id: string
  title: string
  url: string
  icon: string | null
  /** Curated ordering — lower sorts first. */
  sortOrder: number
  /** 0/1 — pinned to the attendee Home as a quick link. */
  quickLink: number
  agendaItemId: string | null
  agendaActivityId: string | null
  agendaGroupId: string | null
  attendeeGroupId: string | null
}

type ListPayload = { success: true; links: EventLink[] }

export function linksKey(eventId: string) {
  return ["event-links", eventId] as const
}

export function linksQueryOptions(eventId: string) {
  return {
    queryKey: linksKey(eventId),
    queryFn: () =>
      api<ListPayload>("/api/v1/event-links/list", { method: "POST", body: { eventId } }),
    select: (p: ListPayload) => p.links,
  }
}

export type LinkInput = {
  title: string
  url: string
  icon?: string | null
  sortOrder?: number
  quickLink?: number
}

export function createLink(eventId: string, input: LinkInput) {
  return api<{ success: true; link: EventLink }>("/api/v1/event-links/create", {
    method: "POST",
    body: { eventId, ...input },
  })
}

export function updateLink(linkId: string, patch: Partial<LinkInput>) {
  return api<{ success: true; link?: EventLink; unchanged?: true }>(
    "/api/v1/event-links/update",
    { method: "POST", body: { linkId, ...patch } },
  )
}

export function deleteLink(linkId: string) {
  return api<{ success: true; linkId: string }>("/api/v1/event-links/delete", {
    method: "POST",
    body: { linkId },
  })
}
